import {Box} from 'quickstart/components/layout/Box'
import styled, {css} from 'quickstart/system'

const getFlexStyles = (align, justify, direction) => css`
  display: flex;
  align-items: ${align || direction === 'column' ? 'flex-start' : 'center'};
  justify-content: ${justify || 'flex-start'};
`

export const FlexContainer = styled(Box)`
  ${props => css`
    flex: ${props.flex || null};
    flex-direction: ${props.direction || null};
  `};
  ${({align, direction, justify}) => getFlexStyles(align, justify, direction)};
`

export const RowContainer = styled(({direction, ...rest}) => (
  <FlexContainer {...rest} direction="row" />
))`
  ${props => css`
    flex: ${props.flex || null};
  `};
  ${({align, justify}) => getFlexStyles(align, justify)};
`

export const StackContainer = styled(({direction, ...rest}) => (
  <FlexContainer {...rest} direction="column" />
))`
  ${props => css`
    flex: ${props.flex || null};
  `};
  ${({align, justify}) => getFlexStyles(align, justify)};
`
